<template>
  <!-- Sidebar -->
  <!--
    Sidebar Mini Mode - Display Helper classes

    Adding 'smini-hide' class to an element will make it invisible (opacity: 0) when the sidebar is in mini mode
    Adding 'smini-show' class to an element will make it visible (opacity: 1) when the sidebar is in mini mode
    If you would like to disable the transition animation, make sure to also add the 'no-transition' class to your element

    Adding 'smini-hidden' to an element will hide it when the sidebar is in mini mode
    Adding 'smini-visible' to an element will show it (display: inline-block) only when the sidebar is in mini mode
    Adding 'smini-visible-block' to an element will show it (display: block) only when the sidebar is in mini mode
    -->
  <simplebar id="sidebar" aria-label="Main Navigation">
    <slot>
      <!-- Side Header -->
      <div
        style="background-color: white !important"
        class="content-header bg-white-5"
      >
        <!-- Logo -->
        <router-link to="/" class="font-w600 text-dual">
          <img
            alt="Ennoble"
            data-src="https://i0.wp.com/proyecto-salvavidas.com/wp-content/uploads/2020/07/Logo.png"
            class="logo"
            src="https://i0.wp.com/proyecto-salvavidas.com/wp-content/uploads/2020/07/Logo.png"
          />
        </router-link>
        <!-- END Logo -->

        <!-- Extra -->
        <div>
          <!-- Options -->

          <!-- Options -->

          <!-- Close Sidebar, Visible only on mobile screens -->
          <base-layout-modifier
            size="sm"
            variant="dual"
            action="sidebarClose"
            class="d-lg-none ml-2"
          >
            <i class="fa fa-times"></i>
          </base-layout-modifier>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Extra -->
      </div>
      <!-- END Side Header -->

      <!-- Side Navigation -->
      <div class="content-side content-side-full">
        <ul class="nav-main" style="color: black !important">
          <li class="nav-main-item">
            <router-link :to="{ name: 'Home' }">
              <a style="text-decoration: none !important" class="nav-main-link"
                ><span class="nav-main-link-name">Mascotas</span></a
              >
            </router-link>
          </li>
          <li class="nav-main-item">
            <router-link :to="{ name: 'ListaFormularios' }">
              <a style="text-decoration: none !important" class="nav-main-link"
                ><span class="nav-main-link-name"
                  >Formularios de Solicitud Publicacion de Rescate</span
                ></a
              >
            </router-link>
          </li>
          <li class="nav-main-item">
            <router-link :to="{ name: 'Drafts' }">
              <a class="nav-main-link" aria-current="page"
                ><span class="nav-main-link-name"
                  >Publicaciones Programadas</span
                ></a
              >
            </router-link>
          </li>
          <li class="nav-main-item">
            <router-link :to="{ name: 'AgregarUsuario' }">
              <a class="nav-main-link"
                ><span class="nav-main-link-name">Agregar Usuario</span></a
              >
            </router-link>
          </li>
          <li class="nav-main-item">
            <router-link :to="{ name: 'Lista' }">
              <a class="nav-main-link"
                ><span class="nav-main-link-name">Lista de Usuarios</span></a
              >
            </router-link>
          </li>
        </ul>
      </div>
      <!-- END Side Navigation -->
    </slot>
  </simplebar>
  <!-- END Sidebar -->
</template>

<script>
// SimpleBar, for more info and examples you can check out https://github.com/Grsmto/simplebar/tree/master/packages/simplebar-vue
import simplebar from "simplebar-vue";

// Get navigation data
import menuList from "@/data/menu";

export default {
  name: "BaseSidebar",
  props: {
    classes: String,
  },
  components: {
    simplebar,
  },
  data() {
    return {
      // Get main navigation
      navigation: menuList.main,
    };
  },
};
</script>
<style>
.logo {
  max-height: 40px;
  margin-left: 50px;
}
a {
  text-decoration: none !important;
}
</style>